
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const StorageInitializer = () => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const verifyBuckets = async () => {
      try {
        // Check if the identity_docs bucket exists
        const { data: buckets, error: listError } = await supabase.storage.listBuckets();
        
        if (listError) {
          console.error('Error listing buckets:', listError);
          return;
        }
        
        const identityDocsBucket = buckets.find(bucket => bucket.name === 'identity_docs');
        
        if (!identityDocsBucket) {
          console.warn('identity_docs bucket not found. It should have been created via SQL migration.');
          return;
        }
        
        console.log('Found identity_docs bucket:', identityDocsBucket);
        
        // List some files in the bucket to verify access
        const { data: files, error: filesError } = await supabase.storage
          .from('identity_docs')
          .list();
          
        if (filesError) {
          console.error('Error listing files in identity_docs bucket:', filesError);
        } else {
          console.log(`Found ${files.length} files/folders in identity_docs bucket:`, 
            files.slice(0, 5).map(f => f.name));
        }
        
        setInitialized(true);
        console.log('Storage buckets verified successfully');
      } catch (error) {
        // Log the error for developers, but don't expose it to users
        console.error('Error verifying storage buckets:', error);
      }
    };

    if (!initialized) {
      verifyBuckets();
    }
  }, [initialized]);

  return null;
};

export default StorageInitializer;
